


























import {Vue, Component, Prop} from 'vue-property-decorator'
import prefixList, {Prefix} from '../../lib/prefixList'
import Utils from '../../utils'
import Validations from '../../lib/Validations'

@Component({
  components: {
    CustomIcon: Utils.loadComponent('CustomIcon'),
    Layout: Utils.loadComponent('proxy/Layout'),
    TextField: Utils.loadComponent('proxy/Inputs/TextField'),
    SelectTag: Utils.loadComponent('proxy/Inputs/SelectTag'),
  },
  name: 'PhonePrefix',
})
export default class PhonePrefix extends Vue {
  @Prop() public phone!: any
  protected rules: any = Validations.rules
  protected prefixList = prefixList

}
